import { ReactNode } from 'react'

import Toaster from '@components/_toast/Toaster'
import CssBaseline from '@mui/material/CssBaseline'
import StyledEngineProvider from '@mui/material/StyledEngineProvider'
import { createTheme, ThemeProvider as ThemeProviderMUI } from '@mui/material/styles'
import ModalProvider from 'mui-modal-provider'

import colorSchemes from './colorSchemes'
import componentOverrides from './overrides'
import Typography from './typography'

export default function ThemeProvider({ children }: { children: ReactNode }) {
	const themeOptions = {
		cssVariables: { colorSchemeSelector: 'class' },
		colorSchemes,
		breakpoints: {
			values: {
				xs: 0,
				sm: 768,
				md: 1024,
				lg: 1266,
				xl: 1536,
			},
		},
		mixins: {
			toolbar: {
				height: 59,
				minHeight: 59,
				paddingTop: 8,
				paddingBottom: 8,
			},
			footer: {
				height: 35,
			},
		},
		typography: Typography,
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					// Change color of highlighted text from react-highlighter
					'.highlight': {
						backgroundColor: colorSchemes.light.palette.secondary.lighter,
					},
				},
			},
			// FIXME: hides the data grid action menu behind open drawers, but the MarketBaskets view
			// needs to be reworked so that drawers can remain open when the menu is closed
			MuiPopper: {
				styleOverrides: {
					root: {
						'&.MuiDataGrid-menu': {
							zIndex: 1000,
						},
					},
				},
			},
			...componentOverrides(),
		},
	}

	// @ts-expect-error: we need to fix the type of createTheme
	const themeOverride = createTheme(themeOptions)

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProviderMUI defaultMode="system" theme={themeOverride} noSsr disableTransitionOnChange>
				<CssBaseline />
				<Toaster />
				<ModalProvider>{children}</ModalProvider>
			</ThemeProviderMUI>
		</StyledEngineProvider>
	)
}
